var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"copyright-footer"},[_c('span',[_vm._v("\n\t\t© iTrack "+_vm._s(_vm.currentYear)+". Todos os direitos reservados.\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }